ko.components.register('domain-field-select', {
	viewModel: function(params) {
		var self = this;

		self.element = false;
		self.tip = false;
		self.showDetails = ko.observable(false);

		self.id = ko.observable(params.id);
		self.name = ko.observable(params.name);

		// data

		self.field = ko.observable();
		self.value = ko.observable();
		self.values = ko.observable();

		self.fieldValue = ko.observable();

		// ajax

		self.loading = ko.observable(false);

		self.ajaxRequest = function(action, params, callback) {
			if(self.loading())
				return;
			self.loading(true);
			return App.ajaxRequest('domain/' + action, params).done(function(r) {
				callback && callback(r);
			}).always(function() {
				self.loading(false);
			});
		};

		self.update = function() {
			if(self.showDetails())
				self.toggleDetails();

			var params = {
				id: self.id(),
				data: {}
			};

			params.data[self.field()] = self.fieldValue() || 0;

			// send update request
			return self.ajaxRequest('update', params, function(r) {
				if(!r)
					return;
				if(r.errors)
					alert(r.errors.join("\n"));
				if(r.ok) {
					self.value(self.fieldValue());
					$(self.element).closest('tr').find('td.' + self.field() + ' .field-value').html(r.value || "");
				}
			});
		};

		self.setData = function(data) {
			self.field((data && data.field));
			self.value((data && data.value));
			self.values((data && data.values) || window._domain[self.field()]);
		};

		// methods

		self.getUID = ko.pureComputed(function() {
			return self.field() + '-' + self.id();
		});

		self.getLabel = ko.pureComputed(function() {
			const v = self.value();
			if(v && self.values() && self.values()[v])
				return self.values()[v];
			return '&nbsp;';
		});

		self.getTitle = ko.pureComputed(function() {
			const v = self.field();
			return v.replace('has_', '').replace('_id', '').replaceAll('_', ' ');
		});

		self.getFieldValues = ko.pureComputed(function() {
			const v = self.values();
			if(!v) return [];
			return Object.keys(v).map(function (k) {
				return {
					'value': k,
					'label': v[k]
				};
			});
		});

		self.toggleDetails = function(data, event) {
			self.showDetails(!self.showDetails());

			if(!self.showDetails()) {
				self.tip
					.stop()
					.animate({left: '15px', opacity: 0}, 200, function() {
						self.element.removeClass('active');
						self.element.popover('hide');
						self.tip.css({left: -1000});
					});
			} else {
				self.fieldValue(self.value());

				if(!self.element)
					self.element = $(event.target);
				if(!self.element.data('bs.popover')) {
					var $details = $('#domain-field-details-' + self.field() + '-' + self.id());
					self.element.popover({
						animation: false,
						placement: 'right',
						html: true,
						content: $details
					});
					$details.show();
					self.tip = $(self.element.data('bs.popover').getTipElement());
				}

				self.element.addClass('active');
				self.element.popover('show');

				self.tip
					.stop()
					.css({left: '15px', opacity: 0})
					.animate({left: 0, opacity: 1}, 200);
			}
		};

		self.setData(params.data || {});
	},
	template: "<div class=\"cursor-pointer domain-field d-block\" data-bind=\"\n\tattr: { 'id': 'domain-field-' + getUID()},\n\thtml: getLabel,\n\tevent: { click: toggleDetails }\"></div>\n<div style=\"display:none;min-width:200px\" data-bind=\"attr: { 'id': 'domain-field-details-' + getUID()}\">\n\t<div class=\"domain-field-details\" data-bind=\"css: { 'loading': loading() }\">\n\t\t<small class=\"spinner spinner-border spinner-primary\" data-bind=\"visible: loading()\"></small>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col mb-2\">\n\t\t\t\t<h5 class=\"domain-field-header\">\n\t\t\t\t\t<span data-bind=\"text: name()\"></span>\n\t\t\t\t\t<small class=\"text-muted\" data-bind=\"text: getTitle\"></small>\n\t\t\t\t</h5>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"domain-field-body\">\n\t\t\t<select class=\"form-control mb-2\" data-bind=\"\n\t\t\t\tvalue: fieldValue,\n\t\t\t\toptions: getFieldValues,\n\t\t\t\toptionsText: 'label',\n\t\t\t\toptionsValue: 'value',\n\t\t\t\toptionsCaption: '- Please Select -'\"></select>\n\n\t\t\t<div class=\"buttons\">\n\t\t\t\t<button class=\"btn btn-primary\" data-bind=\"click: update\">Update</button>\n\t\t\t\t<button class=\"btn btn-secondary\" data-bind=\"attr: {'data-parent': '#domain-field-' + getUID()}, click: toggleDetails\">Cancel</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"
});